<template>
  <!-- <div
    :title="data.subtitle"
    :class="'card ' + type"
    @mouseenter="showdimmer(data.type, $event)"
    @mouseleave="hiddendimmer(data.type, $event)"
  > -->
  <div
    :title="data.subtitle"
    :class="{['card ' + type]: true, 'shake-card': data.isNew}"
  >
    <img :class="'icon ' + type" :src="data.icon_url" />
    <h2>{{data.title}}</h2>
    <p>{{data.subtitle}}</p>
    <div v-if="data.type === 'download'" class="dimmer hidden">
      <div>
        <a v-if="data.website_url" :href="data.website_url" target="_blank"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABtklEQVQ4jZWUP0iWURTGf0roUkZ8S0tKIQQR2BIN0VZDNjc6SXOLk7ZF1BDREP2h2oqCEhzCIBIUggiJCPogJ4MwSkQtyA+t/DW89+W7vN370fvAgZf3Pvc5z7mHc1CpGYfVS+prdU39pc6rx1W6VDpgADgLnAD2AjuBQ+FsE5gB5oF+4DQwmHOxW70bsuewoV5Ue8Ody+qplMODwDRwoJP1CG+A4eCwVRVsAO+Aff8pFou+AJ5WS32i/lDfVspbV6fVl2or8wRf1O5Y7Kj6Tb2ibkfEKbUR8farrxKCm2p/LHhNPRcOSjTVHv9t2h51JSE6EZNOqgsVwlhCrIybCcHZmHA1QaiLlbLLA8AC0Fuzu1W4I3xcyIh9AL7WEGyh9qk/MyWMd3jDZHSpo8C9TMaPwBCwlTgbB45U/j1GfRTc3M64fGB7Xss4n+D9UQdRF9XVcGkuI7oUEl5X32c4d1Sw2CjPbU/BcuZCJzQtNhTdwEb0RosUW2O5RmebwBngOwDqpMXwD9keq4ngfDtnSf2t3iqdGXW5AdwIWVrAZ+AZcB/YBYwAxyi28hawBMwCD4FPVbt/AbYtj7zLEuWaAAAAAElFTkSuQmCC" /><p>网页版</p></a>
        <a v-if="data.android_url" :href="data.android_url" target="_blank"><img src="data:image/svg+xml;utf8;base64,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" /><p>Android</p></a>
        <a v-if="data.ios_url" :href="data.ios_url" target="_blank"><img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3OC4xNTQgNDc4LjE1NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc4LjE1NCA0NzguMTU0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCI+CjxnPgoJPHBhdGggaWQ9IkFwcGxlXzNfIiBkPSJNMjYzLjcyOCwzNi4xODFDMjgwLjk0MiwxNS45MzksMzA5Ljk3MSwwLjk1NiwzMzMuODE5LDBjMy4xNDgsMjguMDMyLTguMDA5LDU2LjA0NS0yNC43NDUsNzYuMzY3ICAgYy0xNi43MTYsMjAuMTYzLTQzLjg5MiwzNS45ODItNzAuNzA5LDMzLjg3QzIzNC43OTksODIuNzAzLDI0OC4yODgsNTQuMTMyLDI2My43MjgsMzYuMTgxeiBNNDAwLjA0NSw0MTguNzkzICAgYy0xOS45NjMsMjkuMTQ4LTQwLjUwNSw1OC4yNTYtNzMuMDc5LDU4Ljc1NGMtMzEuODM4LDAuNTc4LTQyLjA5OC0xOC45ODctNzguNTM5LTE4Ljk4N2MtMzYuNDYsMC00Ny44OTYsMTguNDg5LTc4LjA0LDE5LjU2NSAgIGMtMzEuMzIsMS4xMzYtNTUuMTA4LTMxLjQtNzUuMTcxLTYwLjU0OGMtNDAuOTAzLTU5LjMxMi03Mi4xNDMtMTY3LjczNi0zMC4xMjQtMjQwLjg1NmMyMC44Mi0zNi40LDU4LjA3Ny01OS40MTIsOTguNTIyLTU5Ljk3ICAgYzMwLjcwMi0wLjYzOCw1OS43OTEsMjAuNzgsNzguNjU4LDIwLjc4YzE4Ljc0OCwwLDU0LjEzMi0yNS43MDEsOTEuMTMtMjEuODU2YzE1LjUyLDAuNTk4LDU5LjE3Myw2LjIzNiw4Ny4yMDUsNDcuMjk4ICAgYy0yLjI1MSwxLjQzNC01Mi4xLDMwLjUyMy01MS41NjIsOTEuMTFjMC43MzcsNzIuMzYyLDYzLjMzNyw5Ni40NSw2My45NzQsOTYuNjY5QzQzMi4zODEsMzUyLjQyNyw0MjIuOTM3LDM4NS4xMjIsNDAwLjA0NSw0MTguNzkzICAgeiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=" /><p>iOS</p></a>
        <a v-if="data.win_url" :href="data.win_url" target="_blank"><img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDQ4MCA0ODAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ4MCA0ODA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cGF0aCBkPSJNMC4xNzYsMjI0TDAuMDAxLDY3Ljk2M2wxOTItMjYuMDcyVjIyNEgwLjE3NnogTTIyNC4wMDEsMzcuMjQxTDQ3OS45MzcsMHYyMjRIMjI0LjAwMVYzNy4yNDF6IE00NzkuOTk5LDI1NmwtMC4wNjIsMjI0ICAgbC0yNTUuOTM2LTM2LjAwOFYyNTZINDc5Ljk5OXogTTE5Mi4wMDEsNDM5LjkxOEwwLjE1Nyw0MTMuNjIxTDAuMTQ3LDI1NmgxOTEuODU0VjQzOS45MTh6IiBmaWxsPSIjRkZGRkZGIi8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==" /><p>Windows</p></a>
        <a v-if="data.mac_url" :href="data.mac_url" target="_blank"><img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3OC4xNTQgNDc4LjE1NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDc4LjE1NCA0NzguMTU0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCI+CjxnPgoJPHBhdGggaWQ9IkFwcGxlXzNfIiBkPSJNMjYzLjcyOCwzNi4xODFDMjgwLjk0MiwxNS45MzksMzA5Ljk3MSwwLjk1NiwzMzMuODE5LDBjMy4xNDgsMjguMDMyLTguMDA5LDU2LjA0NS0yNC43NDUsNzYuMzY3ICAgYy0xNi43MTYsMjAuMTYzLTQzLjg5MiwzNS45ODItNzAuNzA5LDMzLjg3QzIzNC43OTksODIuNzAzLDI0OC4yODgsNTQuMTMyLDI2My43MjgsMzYuMTgxeiBNNDAwLjA0NSw0MTguNzkzICAgYy0xOS45NjMsMjkuMTQ4LTQwLjUwNSw1OC4yNTYtNzMuMDc5LDU4Ljc1NGMtMzEuODM4LDAuNTc4LTQyLjA5OC0xOC45ODctNzguNTM5LTE4Ljk4N2MtMzYuNDYsMC00Ny44OTYsMTguNDg5LTc4LjA0LDE5LjU2NSAgIGMtMzEuMzIsMS4xMzYtNTUuMTA4LTMxLjQtNzUuMTcxLTYwLjU0OGMtNDAuOTAzLTU5LjMxMi03Mi4xNDMtMTY3LjczNi0zMC4xMjQtMjQwLjg1NmMyMC44Mi0zNi40LDU4LjA3Ny01OS40MTIsOTguNTIyLTU5Ljk3ICAgYzMwLjcwMi0wLjYzOCw1OS43OTEsMjAuNzgsNzguNjU4LDIwLjc4YzE4Ljc0OCwwLDU0LjEzMi0yNS43MDEsOTEuMTMtMjEuODU2YzE1LjUyLDAuNTk4LDU5LjE3Myw2LjIzNiw4Ny4yMDUsNDcuMjk4ICAgYy0yLjI1MSwxLjQzNC01Mi4xLDMwLjUyMy01MS41NjIsOTEuMTFjMC43MzcsNzIuMzYyLDYzLjMzNyw5Ni40NSw2My45NzQsOTYuNjY5QzQzMi4zODEsMzUyLjQyNyw0MjIuOTM3LDM4NS4xMjIsNDAwLjA0NSw0MTguNzkzICAgeiIgZmlsbD0iI0ZGRkZGRiIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=" /><p>Mac</p></a>
      </div>
    </div>
    <a
      v-if="data.type === 'website'"
      class="linker"
      :href="data.website_url"
      :target="data.target || '_blank'"></a>
    <a
      v-if="data.type === 'aivideo'"
      class="linker"
      @click.prevent="openAIVideo(data.website_url)"
      href="#"
      :target="data.target || '_blank'"></a>
    <div class="help-button" v-if="data.helpUrl" @click="openVideo(data.helpUrl, data.title)">
      帮助视频<span class="help-icon"></span>
    </div>
    <img v-if="data.isNew" src="../images/new.gif" alt="new" class="new-icon">
  </div>
</template>

<script>
export default {
  name: "card",
  props: ['type', 'data'],
  methods: {
    // showdimmer: (type, event) => {
    //   if (type === 'download') {
    //     event.target.querySelector('.dimmer').classList.remove('hidden');
    //   }
    // },
    // hiddendimmer: (type, event) => {
    //   if (type === 'download') {
    //     event.target.querySelector('.dimmer').classList.add('hidden');
    //   }
    // }
    openVideo(videoUrl, title) {
      // console.log(videoUrl)
      this.$openVideo(videoUrl, title);
    },
    openAIVideo(host) {
      function setCookie(name, value, domain) {
        let path = '/';
        let str = name + '=' + value + '; ';
        str += 'path=' + path + '; ';
        if(domain) str += 'domain=' + domain;
        document.cookie = str;
      }
      function getCookie(name){
        let c_start
        let c_end
          if (document.cookie.length>0){
            c_start=document.cookie.indexOf(name+"=");
            if (c_start!=-1){
              c_start=c_start + name.length+1;
              c_end=document.cookie.indexOf(";",c_start);
              if (c_end==-1){ 
                  c_end=document.cookie.length;
              }
              return unescape(document.cookie.substring(c_start,c_end));
            }
        }
        return "";
      }
      if (getCookie('aivideo') !== this.$userid) {
        setCookie('aivideo', this.$userid)
        // setCookie('user_seq_id', getCookie('user_seq_id'), '.xinhua-news.com')
        // setCookie('verifycode', getCookie('verifycode'), '.xinhua-news.com')
      }
      window.open(`${host}/api/v1/onvideo/ai-video/cmp/enteronvideo?app=gg&loginName=${this.$userid}`)
    },
  }
}
</script>

<style lang="scss">
@mixin box-style {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.06);
}
@mixin box-filler {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 20px;
  right: 0;
  z-index: 1;
  cursor: pointer;
}

  @keyframes shake { /* 水平抖动，核心代码 */
      10%, 90% { transform: translate3d(-1px, 0, 0); }
      20%, 80% { transform: translate3d(+2px, 0, 0); }
      30%, 70% { transform: translate3d(-4px, 0, 0); }
      40%, 60% { transform: translate3d(+4px, 0, 0); }
      50% { transform: translate3d(-4px, 0, 0); }
  }

.shake-card {
  animation: shake 800ms ease-in-out 2;
}
.card {
  @include box-style;
  display: inline-block;
  position: relative;
  width: 300px;
  height: 115px;
  padding: 20px 18px;
  margin: 10px;
  .icon {
    width: 55px;
    height: auto;
    margin-right: 20px;
    float: left;
  }
  .icon.fonts {
    display: block;
    float: none;
    margin: auto;
    width: auto;
    height: 60px;
  }
  .help-button {
    position: absolute;
    bottom: -1px;
    right: 5px;
    color: #8ab8e7;
    font-size: 12px;
    cursor: pointer;
    .help-icon {
      background: url(../images/question-mark.png) no-repeat;
      display: inline-block;
      vertical-align: middle;
      height: 23px;
      width: 20px;
    }
  }
  .new-icon {
    position: absolute;
    width: 28px;
    height: 12px;
    top: 8px;
    right: 8px;
  }
  h2 {
    margin: 5px 0;
    font-weight: 500;
  }
  p {
    color: #999;
    font-size: 0.9em;
    // http://www.w3cplus.com/solution/ellipsis/ellipsis.html
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  // &:hover {
  //   cursor: pointer;
  // }

  .dimmer {
    @include box-filler;
    background-color: rgb(19, 142, 246);
    opacity: 0.902;
    border-radius: 4px;
    text-align: center;
    vertical-align: middle;
    div{
      width:100%;
      height:100%;
      margin:0;
      /*text-align:justify;*/
      a{
        display:inline-block;
        text-decoration: none;
        /*line-height: normal;*/
        margin-top:30px;
        text-align: center;
        img {
          max-width: 40px;
        }
      }
      a:nth-child(2){
        margin-left:20px;
      }a:nth-child(3){
        margin-left:20px;
      }
      p{
        color: #fff;
        margin-top:10px;
        font-size: 12px;
      }
    }
    img {
      width: 20px;
      height: 20px;
      display: inline-block;
      /*margin: 30px 20px;*/
    }
  }
  .hidden {
    display: none;
  }
  .linker {
    @include box-filler;
  }
}
</style>
